import React, { Component } from 'react'
import { SiAltiumdesigner } from 'react-icons/si'
import { CgWebsite } from 'react-icons/cg'

export default class Serivces extends Component {
  render() {
    return (
        <section className='services'>
            <div className="kirishSoz">
                <h1>Services</h1>
            </div>
            <ul>
                <li>
                    <SiAltiumdesigner />
                    <h2>web design</h2>
                    <p>
                        Men yoshlig chog'imdan beri frontentda tajribamni ortirmoqdaman va men frontent dasturlasning asosoiy qismi ekanini chundim
                    </p>
                </li>
                <li>
                    <CgWebsite />
                    <h2>Web deveper</h2>
                    <p>
                        Bugungi kunda har qanday biznega internet kerak. Internet Ilovalarining eng sarasi bu Bularning eng sarasi esa web sayitlardur
                    </p>
                </li>
            </ul>
        </section>
    )
  }
}
